import { BROWSER, DEV } from 'esm-env';
export { building, version } from '__sveltekit/environment';

export const browser = BROWSER;

export const dev = DEV;
